import { render } from "./ModalEndConcept.vue?vue&type=template&id=54cb2c5a"
import script from "./ModalEndConcept.vue?vue&type=script&lang=js"
export * from "./ModalEndConcept.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__